namespace Nobox {
    export interface WaktuRequest {
        sDate?: string;
        lDate?: string;
    }
}
